import { render, staticRenderFns } from "./ConfigEditorList.vue?vue&type=template&id=16838d7a&scoped=true&"
import script from "./ConfigEditorList.vue?vue&type=script&lang=js&"
export * from "./ConfigEditorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16838d7a",
  null
  
)

export default component.exports